<template>
  <div class="title-list">
    <div
      v-for="(title, index) in titleList"
      :key="index"
      class="cell-title"
      v-html="titleHTML(title, index)"
    />
  </div>
</template>
<script setup>
  import { defineProps } from 'vue'
  import { replaceSpecialCharacters } from '@/common/utils/common'
  import { changeColorSearchWord } from '@/common/resources/directives'
  const props = defineProps({
    titleList: {
      type: Array,
      default: null,
    },
    cellType: {
      type: String,
      default: '',
    },
    searchWord: {
      type: String,
      default: '',
    },
  })

  const titleHTML = (title, index) => {
    let text = title?.text || ''
    let maxLine = Number(title?.maxline || '1')

    if (text === '') {
      if (index === 1 && props.cellType === 'landscape') {
        return `<span class="title${index + 1} line1">&nbsp;</span>`
      }
      return ''
    }

    if (typeof props.searchWord === 'string') {
      text = changeColorSearchWord(
        text,
        replaceSpecialCharacters(props.searchWord),
      )
    }

    if (text.includes('$O$')) {
      text = text.replace(/\$O\$/gi, '<span class="icon-dotted"></span>')
    }

    if (title.text.includes('<br')) {
      maxLine = 2
    }

    const titleClass = `title${index + 1} line${maxLine}`

    return `<span class="${titleClass}">${text}</span>`
  }
</script>
